import React from "react"

import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {DashboardTemplateConfig} from "../../../../../../core/gd-modules/dashboard/templates/templates-custom"
import FormError from "../../../../../../core/gd-form/common/form-error/form-error"
import Form from '../../../../../../core/gd-form/form/deprecated/form-add/form-add'
import FormManager from "../../../../../../core/gd-form/common/form-manager"
import FieldsFactory from "../../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../../core/fields3/field-type"
import FieldFormElement from "../../../../../../core/fields3/render/form-elemnent"
import {createProjectDashboard} from "../../actions/create-project-dashboard"
import {ConstProject} from "../../../../../../core/gd/const/project"
import {EntityType} from "../../../../../../core/gd/const/item"
import QuickAdd_BreadcrumbNavigation from "../../../../layout/page-title/form-title-breadcrumb"
import {BreadcrumbElement} from "../../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddBreadcrumbElement} from "../../../../@types"
import {createProjectDashboardFromTemplate} from "../../actions/create-project-dashboard-from-template";
import Template from "../../../../../../core/model2/template/template";

type Props = {
    className?      : string

    parent          : any
    gdTemplate?     : DashboardTemplateConfig
    myTemplate?     : Template
    initParams      : any
}

export default function SelectDashboardProjectForm(props: Props) {

    const onSubmit = (formData:any) => {
        if (props.gdTemplate) {
            createProjectDashboard(formData.projectId, props.gdTemplate, props.initParams)
        }
        if (props.myTemplate) {
            createProjectDashboardFromTemplate(formData.projectId, props.myTemplate, props.initParams)
        }
    }

    const fieldProject = FieldsFactory.get({
        fieldId         : 'projectId',
        type            : FieldType.PROJECT,
        parentsFor      : EntityType.DOCUMENT,
        isRequired      : true,
        noValueOption   : false,
        accessLevels    : [ConstProject.access.FULL]
    })

    const initFormData = {
        projectId: props.initParams.projectId
    }

    const formStructure = {
        fields: {
            // name        : { type: 'string', isRequired: true},
            projectId   : { type: 'select', isRequired: true},
        },
        onSubmit: onSubmit
    };
    const form = new FormManager(formStructure,initFormData);

    const templateName = props.gdTemplate?.name || props.myTemplate?.name


    const breadcrumbItems: BreadcrumbElement[] = [
        QuickAddBreadcrumbElement.DASHBOARD,
        QuickAddBreadcrumbElement.PROJECT_DASHBOARD,
        {
            label: templateName || "Empty",
        }
    ]

    return (
        <VScroll className="new-main dashboard new-form">
            <QuickAdd_BreadcrumbNavigation breadcrumbItems={breadcrumbItems}/>
            <div className="quick-add-content m-t-35">
                <Form form={form} submitBtnClass="grey">
                    <div className="tbl">
                        <div className="row planning">
                            <div className="label">Project</div>
                            <div className="element">
                                <FieldFormElement field={fieldProject} form={form} />
                                <FormError form={form} name="projectId" />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </VScroll>
    )
}
